// Punto de entrada de panel-cliente.
// Fase 5 — reemplaza el placeholder de Fase 1. Bootstrap de la SPA:
// inicializa sesión, registra rutas y arranca el router. Mismo patrón que
// panel-super-admin/main.js — ver su comentario de cabecera.
//
// Autenticación: el login de usuarios existentes vive en /login del panel.
// Si no hay sesión, las guardas redirigen a /login.

import { instalarErrorBoundary } from '@plataforma/utils';

instalarErrorBoundary({ prefijo: 'panel-cliente' });

import '@plataforma/ui/src/estilos-base.css';
import '@plataforma/ui/src/estilos-layout.css';
import '@plataforma/ui/src/index.js';

import '../styles/main.css';

import {
  iniciarEnrutador,
  refrescarRuta,
  registrarGuardaNavegacion,
  registrarRuta,
  registrarRutaNoEncontrada,
} from './enrutador.js';
import { suscribirseASesion, inicializarSesion } from './estado-sesion.js';
import { resolverRedireccionRutaEmpresa } from './guardas.js';
import { vistaCambiarContrasena } from './vistas/cambiar-contrasena.js';
import { vistaCambiarPlan } from './vistas/cambiar-plan.js';
import { vistaCategorias } from './vistas/categorias.js';
import { vistaCupones } from './vistas/cupones.js';
import { vistaDashboard } from './vistas/dashboard.js';
import { vistaEmpresaSuspendida } from './vistas/empresa-suspendida.js';
import { vistaEmpresa } from './vistas/empresa.js';
import { vistaLogin } from './vistas/login.js';
import { vistaPaginaPrincipal } from './vistas/pagina-principal.js';
import { vistaPagos } from './vistas/pagos.js';
import { vistaPersonalizarTienda } from './vistas/personalizar-tienda.js';
import { vistaProductos } from './vistas/productos.js';
import { vistaSinPermiso } from './vistas/sin-permiso.js';
import { vistaVariantes } from './vistas/variantes.js';

registrarRuta('/login', vistaLogin);
registrarRuta('/cambiar-contrasena', vistaCambiarContrasena);
registrarRuta('/sin-permiso', vistaSinPermiso);
registrarRuta('/', vistaDashboard);
registrarRuta('/productos', vistaProductos);
registrarRuta('/variantes', vistaVariantes);
registrarRuta('/cupones', vistaCupones);
registrarRuta('/categorias', vistaCategorias);
registrarRuta('/pagina-principal', vistaPaginaPrincipal);
registrarRuta('/personalizar-tienda', vistaPersonalizarTienda);
registrarRuta('/empresa', vistaEmpresa);
registrarRuta('/empresa-suspendida', vistaEmpresaSuspendida);
registrarRuta('/pagos', vistaPagos);
registrarRuta('/cambiar-plan', vistaCambiarPlan);
registrarGuardaNavegacion(resolverRedireccionRutaEmpresa);
registrarRutaNoEncontrada((contenedor) => {
  contenedor.innerHTML = `
    <div class="pf-login">
      <div class="pf-tarjeta pf-login__tarjeta" style="text-align:center;">
        <h1 class="pf-login__titulo">404</h1>
        <p class="pf-texto-suave">Esta página no existe.</p>
        <a href="#/" class="pf-boton pf-boton--primario">Ir al dashboard</a>
      </div>
    </div>
  `;
});

async function iniciar() {
  const app = document.getElementById('app');

  await inicializarSesion();

  // Cada cambio de sesión (login, logout, expiración) re-renderiza la ruta
  // actual — ver panel-super-admin/main.js para la misma nota.
  suscribirseASesion(() => refrescarRuta());

  iniciarEnrutador(app);
}

iniciar();
